import { useContext } from 'react';

import { AuthContext, TAuthContext } from './AuthContext';

export const useAuth = <PAuthenticated extends boolean>() =>
  useContext(AuthContext) as Extract<TAuthContext, { authenticated: PAuthenticated }>;
